<template>
    <Row type="none" class="bg-white rounded shadow min-h-screen p-3">
        <Modal
            :text="modalText"
            id="modal_show"
        />

        <div class="grid grid-cols-12 gap-3">
            <div class="col-span-10 position-relative mt-4">
                <div class="font-bold text-sm bg-white px-1 text-fontColor z-30 position-absolute -top-3 ml-2">
                    {{ $t('warehouse.name') }}
                </div>
                <div>
                    <b-form-input class="focus:ring-0 border-gray-300 h-11" v-model="modelForm.name"/>
                    <b-form-invalid-feedback :state="modelNotEmptyState('name')">
                        {{ errors.name }}
                    </b-form-invalid-feedback>
                </div>
            </div>

            <div class="col-span-2 position-relative mt-4">
                <SubmitButton
                    class="w-full"
                    :is-disabled="hasErrors || hasNotChanged"
                    :is-loading="isLoading"
                    :do-action="add"
                    :text="$route.params.id ? $t('edit') : $t('add')"
                />
            </div>
        </div>
    </Row>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SubmitButton from "../../components/html/SubmitButton";
import validatorMixin from "../../mixin/validatorMixin";
import Modal from "@/components/html/Modal";
import Row from "@/components/html/Row.vue";

export default {
    name: "ProductsAdd",
    components: {
        Row,
        SubmitButton,
        Modal,
    },
    mixins: [validatorMixin],
    data() {
        return {
            modalText: '',
            isLoading: false,
            errors: {
                name: null
            },
            breadcrumbItems: [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'add'},
            ],
            modelForm: {
                name: '',
            },
        }
    },
    computed: {
        ...mapGetters(['getWarehouse']),
        hasNotChanged() {
            if (this.$route.name === 'warehouse/show') {
                return this.modelForm.name === this.getWarehouse.name
            }

            return false
        }
    },
    methods: {
        ...mapActions(['pushWarehouse', 'fetchOneWarehouse', 'setBreadcrumbItems']),
        add() {
            this.isLoading = true
            this.modelForm.name = this.modelForm.name.charAt(0).toUpperCase() + this.modelForm.name.slice(1).toLowerCase()

            this.pushWarehouse(this.modelForm)
                .then(() => {
                    this.isLoading = false
                    this.$i18nHelper.toUrl('warehouses')
                })
                .catch((reason) => {
                    if (reason === 'You have not available credits') {
                        this.isLoading = false
                        this.modalText = this.$t('error.overLimit')
                        this.$bvModal.show('modal_show')
                    } else {
                        this.isLoading = false
                        this.modalText = reason
                        this.$bvModal.show('modal_show')
                    }
                })
        },
    },
    created() {
        if (this.$route.name === 'warehouse/show') {
            this.breadcrumbItems = [
                {name: 'home', url: ''},
                {name: 'warehouse.title', url: 'warehouses'},
                {name: 'edit'},
            ]
        }

        this.setBreadcrumbItems(this.breadcrumbItems)
    },
    mounted() {
        if (this.$route.name === 'warehouse/show') {
            window.scrollTo(0, 0)

            this.fetchOneWarehouse(this.$route.params.id)
                .then(() => {
                    this.modelForm.id = this.getWarehouse.id
                    this.modelForm.name = this.getWarehouse.name
                })
        }
    },
}
</script>

<style scoped>

</style>